import { defineMessages } from 'react-intl';

const scope = 'app.components.GenericPageError';

export default defineMessages({
    errorMessage: {
        id: `${scope}.errorMessage`,
        defaultMessage: "We're sorry, something went wrong.",
    },
});
